export default __webpack_public_path__ + "static/media/1017.2d60427b.png";